import { render, staticRenderFns } from "./Index1.vue?vue&type=template&id=54a70ba0&scoped=true&"
import script from "./Index1.vue?vue&type=script&lang=js&"
export * from "./Index1.vue?vue&type=script&lang=js&"
import style0 from "./Index1.vue?vue&type=style&index=0&id=54a70ba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a70ba0",
  null
  
)

export default component.exports